const $ = jQuery.noConflict();

'use strict';
const FindUsSavingData = {

	// initialize
	init: function() {
		if ($('.js-listing-blocks__list').length === 0) {
			return;
		}
		this.sendRequest();
	},

	// send form submission
	sendRequest: function() {
		$('.js-find-us-redirect').on('click', (e)=>{
			e.preventDefault();
			const currentHref = $(e.currentTarget).attr('href');

			// dispatch request
			$.ajax({
				url: window.fwsLocalized.ajaxUrl,
				type: 'POST',
				data: {
					action: 'find_us',
					current_href: currentHref, //eslint-disable-line camelcase
				},
				success: function(response) {
					if (response.data.success !== true) {
						return;
					}
					window.location.href = currentHref;
				}
			});
		});
	},

};

export default FindUsSavingData;
